module.exports = __webpack_public_path__ + "public/images/schedule/schedule-bel-table.7f6e80d206eb04e985bdc696e6fc2d61.svg";